<template>
  <hr class="mc-line" :style="{height:lineHeight + 'px', 'margin-bottom':marginBottom + 'px'}">
</template>
<script type="text/ecmascript-6">
  export default {
    props:{
      lineHeight: {
        type: [String, Number],
        default: 1
      },
      marginBottom:{
        type: [String, Number],
        default: 14
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/base-line.vue